import { createContext, useContext } from 'react';
export const CreateGiveawayFormContext = createContext(null);
export const useCreateGiveawayFormContext = () => {
    const context = useContext(CreateGiveawayFormContext);
    if (!context) {
        throw new Error('useCreateGiveawayFormContext must be used within CreateGiveawayFormContext.Provider');
    }
    return context;
};
